import Api from '@/services/Api'

const state = {
  fleets: localStorage.getItem('fleets') ? JSON.parse(localStorage.getItem('fleets')) : [],
  selected_fleet: localStorage.getItem('selected_fleet') && localStorage.getItem('selected_fleet') !== 'undefined' ? JSON.parse(localStorage.getItem('selected_fleet')) : {},
}
function refreshFleetData (commit, payload) {
}
const mutations = {
  set_users (state, vehicles) {
    state.vehicles = vehicles
  },
  set_fleets (state, fleets) {
    state.fleets = fleets
    state.selected_fleet = fleets[0]
    localStorage.setItem('fleets', JSON.stringify(fleets))
    localStorage.setItem('selected_fleet', JSON.stringify(fleets[0]))
  },
  selected_fleet (state, selected_fleet) {
    state.selected_fleet = selected_fleet
    localStorage.setItem('selected_fleet', selected_fleet)
    sessionStorage.removeItem('notifications');
  }
}

const getters = {
  fleets () {
    return state.fleets
  },
  selected_fleet () {
    return state.selected_fleet
  },
  fleet_vehicles () {
    return state.vehicles
  }
}
const actions = {
  selected_fleet ({ commit }, payload) {
    state.selected_fleet = payload
    commit('selected_fleet', payload)
    localStorage.setItem('selected_fleet', JSON.stringify(payload))
    refreshFleetData(commit, payload)
  },
  set_fleet ({ commit }, payload) {
    commit('set_fleets', payload)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
